import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import DateTime from 'react-datetime'
import NumInputNoToolTip from '../NumInput/NumInputNoToolTip.jsx'
import _ from 'lodash'
import Select, { components } from 'react-select'
import { autoCompleteOff } from 'Helper/autoCompleteOff.js'

class InputGroupText extends React.Component {
  // this was a fix for Non-XIS date issue # 2926. The 'date' case below
  // had value={this.state.value}. But that seemed to break other dates
  // in the app. I reverted it back and I don't seem to be having any issues.
  // Keeping this here until that issue is addressed
  // constructor(props) {
  //   super(props)
  //   this.state = {
  //     value: props.value
  //   }
  // }
  constructor(props) {
    super(props)
    this.htmlFor = props.id || _.uniqueId('inputGroupText_')
    this.elementRef = React.createRef()
    this.state = {
      selectDirection: props.menuLocation == 'top' ? 'top' : 'bottom'
    }
  }
  componentDidMount() {
    // this is dreadful, but I can't find a better way that actually works
    if (typeof window !== 'undefined') {
      const $ = window.jQuery
      if (typeof $ === 'function') {
        $('.input-select input').attr('autoComplete', 'off')
      }
    }

    if (this.props.type === 'select' && this.elementRef.current && this.props.menuLocation === 'auto') {
      // if this is a select type element, setup an observer to watch the select menus location
      // on the screen and determine wheather it should open up or down.
      let options = {
        root: null,
        rootMargin: "-50% 0% 0% 0%",
        threshold: 1,
      };

      const observer = new IntersectionObserver((entry) => { this.setState({ selectDirection: entry[0]?.isIntersecting ? 'top' : 'bottom' }) }, options);
      observer.observe(this.elementRef.current);
    }
  }

  invalidDate = () => {
    const date = this.props.value
    const format = this.props.dateFormat || 'YYYY-MM-DD'
    let highlightDate = ''

    if (date !== '') {
      highlightDate = !moment(date, format).isValid() ? 'red-border ' : ''
    }

    return highlightDate
  }
  inputType() {
    const {
      disabled,
      title,
      value,
      stretch,
      fitTitle,
      type,
      onChange = () => null,
      onBlur = () => null,
      dateFormat,
      timeFormat = true,
      valueClassName = '',
      titleClassName = '', // even though this isn't used it has to be pulled out of ...rest
      menuHeight,
      options,
      valueKey = 'value',
      labelKey = 'label',
      id,
      checked,
      ...rest
    } = this.props

    // make sure we dont end up with a tooltip directly on the input as well
    delete rest['data-toggle']
    delete rest['data-title']
    delete rest['data-placement']

    const disabledText = disabled ? 'disabled' : false
    switch (type) {
      case 'date':
        return (
          <DateTime
            value={value}
            className={this.invalidDate() + valueClassName}
            inputProps={{
              ...autoCompleteOff,
              'aria-label': `${title} input`,
              disabled,
              ...rest,
              id: this.htmlFor
            }}
            dateFormat={dateFormat || 'YYYY-MM-DD'}
            timeFormat={timeFormat}
            onChange={date => {
              // if the date is a valid moment date, format it and
              // call the parent onChange if there was one
              if (date instanceof moment) {
                const timeFormat =
                  this.props.timeFormat != null &&
                    this.props.timeFormat != false
                    ? ' ' + this.props.timeFormat
                    : ''
                const format =
                  dateFormat == null ? 'YYYY-MM-DD' : dateFormat + timeFormat
                // have to make a fake event object
                onChange({
                  target: { value: moment(date).format(format) }
                })
              } else if (date === '') {
                onChange({
                  target: { value: date }
                })
              }
            }}
            onClose={date => {
              // without the if, date inputs that were clicked in/out of without
              // any changes would give an Invalid Date error
              if (date !== '') {
                const timeFormat =
                  this.props.timeFormat != null &&
                    this.props.timeFormat != false
                    ? ' ' + this.props.timeFormat
                    : ''
                const format =
                  dateFormat == null ? 'YYYY-MM-DD' : dateFormat + timeFormat
                const result = {
                  target: {
                    value: moment(date, 'YYYY-MM-DD', true).format(format)
                  }
                }
                onBlur(result)
              } else {
                const result = {
                  target: { value: '' }
                }
                onBlur(result)
              }
            }}
            isValidDate={(current, selected) => {
              if (this.props.min != null && this.props.max != null) {
                return (
                  current.isAfter(moment(this.props.min)) &&
                  current.isBefore(moment(this.props.max))
                )
              } else if (this.props.min != null && this.props.max == null) {
                return current.isAfter(moment(this.props.min))
              } else if (this.props.min == null && this.props.max != null) {
                return current.isBefore(moment(this.props.max))
              } else if (this.props.isValidDate != null) {
                return this.props.isValidDate(current, selected)
              } else {
                return true
              }
            }}
            {...rest}
          />
        )
      case 'area':
      case 'textarea':
        return (
          <textarea
            id={this.htmlFor}
            className={'input-group-addon text-input ' + valueClassName}
            disabled={disabled}
            aria-label={`${title} input`}
            {...autoCompleteOff}
            value={
              value ||
              '' /* explicitly set to avoid changing controlled to uncontrolled */
            }
            onChange={onChange}
            onBlur={onBlur}
            {...rest}
          />
        )
      case 'number':
        return (
          <NumInputNoToolTip
            id={this.htmlFor}
            className={'input-group-addon text-input ' + valueClassName}
            disabled={disabled}
            aria-label={`${title} input`}
            {...autoCompleteOff}
            value={
              value ||
              0 /* explicitly set to avoid changing controlled to uncontrolled */
            }
            onChange={onChange}
            onBlur={onBlur}
            numstyle={this.props.numstyle}
            {...rest}
          />
        )
      case 'zip':
        return (
          <input
            id={this.htmlFor}
            maxLength="10"
            minLength="5"
            type="text"
            className={'input-group-addon text-input ' + valueClassName}
            disabled={disabled}
            aria-label={`${title} input`}
            {...autoCompleteOff}
            value={
              value ||
              '' /* explicitly set to avoid changing controlled to uncontrolled */
            }
            onChange={onChange}
            onBlur={onBlur}
            {...rest}
          />
        )
      case 'picky': {
        return (
          <div style={{ backgroundColor: 'red', color: 'white', padding: '6px' }}>
            Picky control is deprecated
          </div>
        )
      }
      case 'select': {
        const DropdownIndicator = props => {
          return (
            components.DropdownIndicator && (
              <components.DropdownIndicator {...props}>
                <span className="caret"></span>
              </components.DropdownIndicator>
            )
          )
        }

        const SingleValue = (singleValueProps) => {
          if (rest.isSearchable && singleValueProps.selectProps.menuIsOpen) {
            return (
              <components.Placeholder {...singleValueProps} isDisabled={false}>
                {singleValueProps.selectProps.placeholder}
              </components.Placeholder>
            )
          }
          return <components.SingleValue {...singleValueProps} />
        }

        const menu = this.state.selectDirection === 'bottom'
          ? base => ({
            ...base,
            zIndex: 100,
            top: '26px'
          })
          : base => ({
            ...base,
            zIndex: 100,
            bottom: '26px'
          })

        const customStyles = {
          control: base => ({
            ...base,
            '&:hover': {
              borderColor: 'hsl(0, 0%, 80%)',
              backgroundColor: '#e6e6e6'
            },
            boxShadow: 'none',
            borderColor: 'hsl(0, 0%, 80%)',
            height: 34,
            minHeight: 34,
            maxHeight: 34,
            paddingLeft: '10px',
            borderBottomLeftRadius: '0',
            borderTopLeftRadius: '0'
          }),
          menu,
          menuList: base => ({
            ...base,
            height: menuHeight || '100px'
          }),
          option: base => ({
            ...base,
            padding: '3px 20px',
            textAlign: 'left'
          }),
          valueContainer: base => ({
            ...base,
            padding: '0',
            display: 'flex',
            justifyContent: 'flex-end',
          }),
          indicatorSeparator: base => ({
            ...base,
            display: 'none'
          }),
          indicatorsContainer: base => ({
            ...base,
            width: '31px'
          }),
          indicator: base => ({
            ...base,
            paddingTop: '0'
          }),
          placeholder: base => ({
            ...base,
            margin: 'auto'
          })
        }
        return (
          <div className={'input-select ' + valueClassName} ref={this.elementRef}>
            <Select
              id={this.htmlFor}
              menuPlacement={this.state.selectDirection}
              value={options?.find(option => option[valueKey] === value)}
              options={options}
              getOptionLabel={option => option[labelKey]}
              getOptionValue={option => option[valueKey]}
              //  classNamePrefix={'Select'}
              isDisabled={disabled}
              isSearchable={false}
              styles={customStyles}
              aria-label={`${title} input`}
              onChange={onChange}
              components={{ DropdownIndicator, SingleValue }}
              {...rest}
            />
          </div>
        )
      }
      default: {
        const size =
          this.props.size != null
            ? this.props.size
            : value != null
              ? value.toString().length * 1.85
              : 1
        return (
          <input
            id={this.htmlFor}
            type={this.props.type || 'text'}
            className={'input-group-addon text-input ' + valueClassName}
            disabled={disabledText}
            aria-label={`${title} input`}
            size={size}
            checked={type === 'checkbox' || type === 'radio' ? checked : undefined}
            {...autoCompleteOff}
            value={
              value ||
              '' /* explicitly set to avoid changing controlled to uncontrolled */
            }
            onChange={onChange}
            onBlur={onBlur}
            {...rest}
          />
        )
      }
    }
  }
  render() {
    const { title, stretch, fitTitle, style, titleClassName, type } = this.props
    let newStyle =
      stretch !== false
        ? { ...style, width: 'auto', textAlign: 'center' }
        : style
    newStyle =
      fitTitle === true ? { ...newStyle, flex: '1 0', width: 'auto' } : newStyle
    // this is to highlight the date input red if it is invalid and show a Invalid Date tooltip
    let invalidDate = ''
    let dataTitle = this.props['data-title'] ? this.props['data-title'] : this.props.title
    let dataToggle = this.props['data-toggle']
    let dataPlacement = this.props['data-placement']
    if (type === 'date') {
      invalidDate = this.invalidDate()

      if (invalidDate !== '') {
        dataTitle = 'Invalid Date'
        dataToggle = 'tooltip'
        dataPlacement = 'top'
      }
    }

    return (
      <div className="input-group-component">
        <div
          className="input-group"
          data-title={dataTitle}
          data-toggle={dataToggle}
          data-placement={dataPlacement || 'top'}
        >
          {title !== ''
            ? (
              <label
                htmlFor={this.htmlFor}
                style={newStyle}
                className={
                  invalidDate +
                  'form-control title input-group-addon ' +
                  titleClassName
                }
                onChange={null}
              >
                {title}
              </label>
            )
            : null}
          {this.inputType()}
        </div>
      </div>
    )
  }
}

InputGroupText.defaultProps = {
  valueClassName: ''
}

InputGroupText.propTypes = {
  // Is the text input disabled
  disabled: PropTypes.bool,
  // Title of the text input
  title: PropTypes.string.isRequired,
  // Value in the text input
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  // should the field stretch full width or be be the equivalent of width = auto
  stretch: PropTypes.bool,
  // should the title container be fit to its contents
  fitTitle: PropTypes.bool,
  // optional class name added to the value portion of the input (e.g., for styling required or invalid entries)
  valueClassName: PropTypes.string,
  // optional prop to determine select menu location
  menuLocation: PropTypes.oneOf(['top', 'bottom', 'auto'])
}

export default InputGroupText
